// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/wheel-landing-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/wheel-landing-technique/wheel-landing-technique.js';

mount([g0]);
